class ProductCardPreview extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        // this.productVariantFieldset = this.querySelector('fieldset');
        // if (this.productVariantFieldset) {
        //     this.productVariantFieldset.addEventListener('change', this.onVariantChange);
        // }
    }

    disconnectedCallback() {
        if (this.productVariantFieldset) {
            this.productVariantFieldset.removeEventListener('change', this.onVariantChange);
        }
    }

    toFixed(number) {
        return Number(number / 100).toFixed(2)
    }

    onVariantChange = () => {
        this.setVariantData();
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateVariantInput();
            this.renderProductInfo();
        }
        document.dispatchEvent(new CustomEvent("variantUpdate"));
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.currentOption = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
              return this.currentOption[index] === option;
            }).includes(false);
          });
    }

    updateVariantInput() {
        const productForm = this.querySelector("product-preview-form");
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        this.setUnavailable(this.currentVariant.available)
    }

    getSelectedVariant() {
        return this.variantData.find((variant) => variant.id === this.currentVariant.id)
    }

    getPriceFromSellingPlan(variant) {
        return variant.selling_plan_allocations.reduce((acc, plan) => {
            if (!acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            if (plan.price < acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            return acc;
        }, { price: null, compare_at_price: null })
    }

    getLowestPrice(variant) {
        if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const planPrice = this.getPriceFromSellingPlan(variant);
            if (planPrice.price > 0) return planPrice;
        }

        return {
            compare_at_price: variant.compare_at_price,
            price: variant.price,
        };
    }

    isDifferenceVariantsPrice() {
        const variants = this.variantData
        if (variants && variants.length > 1) {
            const variantPrices = variants.map((variant) => variant.price)
            const uniqPrices = [...new Set(variantPrices)];
            return uniqPrices.length > 1;
        }

        return false;
    }

    removeErrorMessage() {
        const productForm = this.querySelector('product-preview-form');
        if (productForm) productForm.handleErrorMessage();
    }

    updatePrice(currentVariant, withFrom) {
        const updatedPrice = this.getLowestPrice(currentVariant);
        const priceContainer = this.querySelector(".product-preview-card__price");

        if (updatedPrice.compare_at_price) {
            priceContainer.innerHTML = `
                ${withFrom ? '<span>From&nbsp;</span>' : ""}
                <s>$${this.toFixed(updatedPrice.compare_at_price)}</s>
                <span> $${this.toFixed(updatedPrice.price)}</span>
            `
        } else {
            priceContainer.innerHTML = `
                ${withFrom ? '<span>From&nbsp;</span>': ""}
                <span>$${this.toFixed(updatedPrice.price)}</span>
            `
        }
    }

    getUpdatedImageSrcset(srcset, newSrc) {
        const regex = /(https:\/\/|\/\/)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(\?v=\d*)/gm
        return srcset.replace(regex, newSrc);
    }

    updateImageElement(imageSrc) {
        const imageObject = this.querySelector("media-gallery img");
        imageObject.src = `${imageSrc}`
        imageObject.srcset = this.getUpdatedImageSrcset(imageObject.srcset, imageSrc)
    }

    updateImages(currentVariant) {
        // thumbnail images
        // const variantImage = this.variantImages.find(({ id }) => id === currentVariant.id)
        // if (variantImage) {
        //     this.updateImageElement(variantImage.src);
        //     return
        // }
        if (currentVariant.featured_image) {
            this.updateImageElement(currentVariant.featured_image.src);
        }
    }

    renderProductInfo() {
        // const currentVariant = this.getSelectedVariant();
        // const isDifferentPrice = this.isDifferenceVariantsPrice();
        // this.updatePrice(currentVariant, isDifferentPrice);
        // this.updateImages(currentVariant);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(`#product-preview-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
        } else {
            addButton.removeAttribute('disabled');
        }

        if (!modifyClass) return;
    }

    setUnavailable(available) {
        const productForm = this.querySelector("product-preview-form");
        const button =  productForm.querySelector("button")
        if (!button) return;
        if(!available) {
        button.setAttribute('disabled', 'disabled');
        button.querySelector("span").textContent = "Sold out";
        } else {
            button.removeAttribute('disabled');
            button.querySelector("span").textContent = "Add to bag";
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

    parseVariantData() {
        const { variants, image_preview } = JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return {
            variants,
            image_preview
        }
    }

    setVariantData() {
        this.variantData = this.variantData || this.parseVariantData().variants;
        this.variantImages = this.variantImages || this.parseVariantData().image_preview;
    }
}

customElements.define('product-card-preview', ProductCardPreview);


class ProductCardInspo extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        // this.productVariantFieldset = this.querySelector('fieldset');
        // if (this.productVariantFieldset) {
        //     this.productVariantFieldset.addEventListener('change', this.onVariantChange);
        // }
    }

    disconnectedCallback() {
        if (this.productVariantFieldset) {
            this.productVariantFieldset.removeEventListener('change', this.onVariantChange);
        }
    }

    toFixed(number) {
        return Number(number / 100).toFixed(2)
    }

    onVariantChange = () => {
        this.setVariantData();
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateVariantInput();
            this.renderProductInfo();
        }
        document.dispatchEvent(new CustomEvent("variantUpdate"));
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.currentOption = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
              return this.currentOption[index] === option;
            }).includes(false);
          });
    }

    updateVariantInput() {
        const productForm = this.querySelector("product-form");
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        this.setUnavailable(this.currentVariant.available)
    }

    getSelectedVariant() {
        return this.variantData.find((variant) => variant.id === this.currentVariant.id)
    }

    getPriceFromSellingPlan(variant) {
        return variant.selling_plan_allocations.reduce((acc, plan) => {
            if (!acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            if (plan.price < acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            return acc;
        }, { price: null, compare_at_price: null })
    }

    getLowestPrice(variant) {
        if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const planPrice = this.getPriceFromSellingPlan(variant);
            if (planPrice.price > 0) return planPrice;
        }

        return {
            compare_at_price: variant.compare_at_price,
            price: variant.price,
        };
    }

    isDifferenceVariantsPrice() {
        const variants = this.variantData
        if (variants && variants.length > 1) {
            const variantPrices = variants.map((variant) => variant.price)
            const uniqPrices = [...new Set(variantPrices)];
            return uniqPrices.length > 1;
        }

        return false;
    }

    removeErrorMessage() {
        const productForm = this.querySelector('product-preview-form');
        if (productForm) productForm.handleErrorMessage();
    }

    updatePrice(currentVariant, withFrom) {
        const updatedPrice = this.getLowestPrice(currentVariant);
        const priceContainer = this.querySelector(".product-preview-card__price");

        if (updatedPrice.compare_at_price) {
            priceContainer.innerHTML = `
                ${withFrom ? '<span>From&nbsp;</span>' : ""}
                <s>$${this.toFixed(updatedPrice.compare_at_price)}</s>
                <span> $${this.toFixed(updatedPrice.price)}</span>
            `
        } else {
            priceContainer.innerHTML = `
                ${withFrom ? '<span>From&nbsp;</span>': ""}
                <span>$${this.toFixed(updatedPrice.price)}</span>
            `
        }
    }

    getUpdatedImageSrcset(srcset, newSrc) {
        const regex = /(https:\/\/|\/\/)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(\?v=\d*)/gm
        return srcset.replace(regex, newSrc);
    }

    updateImageElement(imageSrc) {
        const imageObject = this.querySelector("media-gallery img");
        imageObject.src = `${imageSrc}`
        imageObject.srcset = this.getUpdatedImageSrcset(imageObject.srcset, imageSrc)
    }

    updateImages(currentVariant) {
        // thumbnail images
        // const variantImage = this.variantImages.find(({ id }) => id === currentVariant.id)
        // if (variantImage) {
        //     this.updateImageElement(variantImage.src);
        //     return
        // }
        if (currentVariant.featured_image) {
            this.updateImageElement(currentVariant.featured_image.src);
        }
    }

    renderProductInfo() {
        // const currentVariant = this.getSelectedVariant();
        // const isDifferentPrice = this.isDifferenceVariantsPrice();
        // this.updatePrice(currentVariant, isDifferentPrice);
        // this.updateImages(currentVariant);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
        } else {
            addButton.removeAttribute('disabled');
        }

        if (!modifyClass) return;
    }

    setUnavailable(available) {
        const productForm = this.querySelector("product-form");
        const button =  productForm.querySelector("button")
        if (!button) return;
        if(!available) {
        button.setAttribute('disabled', 'disabled');
        button.querySelector("span").innerHTML = '  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M6.5 2L3.5 6V20C3.5 20.5304 3.71071 21.0391 4.08579 21.4142C4.46086 21.7893 4.96957 22 5.5 22H19.5C20.0304 22 20.5391 21.7893 20.9142 21.4142C21.2893 21.0391 21.5 20.5304 21.5 20V6L18.5 2H6.5Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 6H21.5" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.5 10C16.5 11.0609 16.0786 12.0783 15.3284 12.8284C14.5783 13.5786 13.5609 14 12.5 14C11.4391 14 10.4217 13.5786 9.67157 12.8284C8.92143 12.0783 8.5 11.0609 8.5 10" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/> </svg>Sold out';
        } else {
            button.removeAttribute('disabled');
            button.querySelector("span").innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M6.5 2L3.5 6V20C3.5 20.5304 3.71071 21.0391 4.08579 21.4142C4.46086 21.7893 4.96957 22 5.5 22H19.5C20.0304 22 20.5391 21.7893 20.9142 21.4142C21.2893 21.0391 21.5 20.5304 21.5 20V6L18.5 2H6.5Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 6H21.5" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.5 10C16.5 11.0609 16.0786 12.0783 15.3284 12.8284C14.5783 13.5786 13.5609 14 12.5 14C11.4391 14 10.4217 13.5786 9.67157 12.8284C8.92143 12.0783 8.5 11.0609 8.5 10" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/> </svg>Add to bag';
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

    parseVariantData() {
        const { variants, image_preview } = JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return {
            variants,
            image_preview
        }
    }

    setVariantData() {
        this.variantData = this.variantData || this.parseVariantData().variants;
        this.variantImages = this.variantImages || this.parseVariantData().image_preview;
    }
}

customElements.define('product-form-inspo', ProductCardInspo);